import { render } from "./Help.vue?vue&type=template&id=19b8fa19&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=19b8fa19&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19b8fa19"

export default script